import { hasCapability, type User } from "../base";

export const sunrunAutomation = {
  read: (user: User) => hasCapability(user, "sunrunAutomation.read"),
  readEventLogs: (user: User) => hasCapability(user, "sunrunAutomation.readEventLogs"),
  update: (user: User) => hasCapability(user, "sunrunAutomation.update"),
  updateSettings: (user: User) => hasCapability(user, "sunrunAutomation.updateSettings"),
  create: (user: User) => hasCapability(user, "sunrunAutomation.create"),
};
